<script>
import { get, sync } from 'vuex-pathify'

export default {
	metaInfo() {
		const { siteName, separator, metaDescription, metaImage } = this.$srv('SitePageTitle', {})
		const titleTemplate = (title) => {
			if (title) {
				return siteName ? `${title} ${separator} ${siteName}` : title
			} else {
				return siteName || ''
			}
		}

		return {
			titleTemplate,
			meta: [
				{ vmid: 'd', name: 'description', content: metaDescription || '' },
				{ vmid: 'og:d', property: 'og:description', content: metaDescription || '' },
				{
					vmid: 'og:t',
					property: 'og:title',
					template: titleTemplate,
				},
				{
					vmid: 'og:i',
					property: 'og:image',
					content: metaImage?.fullUrl || this.$srv('AppBarConfig.img')?.fullUrl || '',
				},
				{
					vmid: 'og:u',
					property: 'og:url',
					content: process.env.VUE_APP_BASE_URL + this.$router.resolve(this.$route).href,
				},
				{
					vmid: 'og:type',
					property: 'og:type',
					content: 'website',
				},
			],
		}
	},
	provide() {
		return {
			getAppMessageDialog: () => this.$refs.appMessageDialog,
		}
	},
	computed: {
		appComponent: get('shop/appComponent'),
		cartAutoRemovals: sync('cart/cartAutoRemovals'),
	},
	eventsListeners: {
		'app-message'(options) {
			this.$refs.appMessageDialog.open(options)
		},
	},
	watch: {
		$route: {
			handler() {
				if (this.$ssr) return
				if (!this.$route.query.goto) return
				// wait until view is rendered
				this.$nextTick(() => {
					const query = { ...this.$route.query }
					delete query.goto
					this.$router.replace({ query })
				})
				const [selector, offset, duration] = this.$route.query.goto.split(':')
				try {
					this.$vuetify.goTo(selector, {
						offset: parseInt(offset) || 0,
						duration: parseInt(duration) || 500,
					})
				} catch (err) {
					// do nothing
				}
			},
			immediate: true,
			deep: true,
		},
	},
	mounted() {
		this.$shopApi.defaults({
			onMessage: ({ message, success }) => {
				if (!message.title && !message.text && !message.description) return
				this.$refs.appMessageDialog.open({
					type: message.type || (success ? 'success' : 'error'),
					title: message.title,
					text: message.text,
					description: message.description,
					//code: message.code,
				})
			},
			onConfirm: ({ confirmed, canceled, options }) => {
				this.$refs.appMessageDialog.open({
					title: options.confirm.title,
					text: options.confirm.text,
					htmlText: options.confirm.htmlText,
					accept: options.confirm.accept,
					cancel: options.confirm.cancel,
					onAccept: confirmed,
					onCancel: canceled,
				})
			},
		})
	},
	cssVars: {
		selector: '.shop-app',
	},
}
</script>

<template>
	<v-app class="shop-app base">
		<AppRouteLoadingBar />
		<component :is="appComponent" id="app" />
		<AppMessageDialog ref="appMessageDialog" />
		<CookiesDisclaimer />
		<CartAutoRemovalsModal />
		<UserCustomFieldsPopup />
	</v-app>
</template>

